import type { Nullish } from '@flemingmetrics/api-client';
import { isBlank, isString } from '@/utils/strings';
import { isBoolean } from '@/utils/boolean';
import isEqual from 'lodash/isEqual';

export function isNullish(val: unknown): val is Nullish {
  return val === null || val === undefined;
}

export function isEmpty(val: unknown): boolean {
  if (isNullish(val)) return true;
  if (isBoolean(val) && !val) return true;
  if (isString(val)) return isBlank(val);
  if (Array.isArray(val)) return val.length === 0;
  return Object.keys(val as Object).length === 0;
}

export function isDeepEqual(a: unknown, b: unknown): boolean {
  return isEqual(a, b);
}

export function pause(time: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, time));
}
